import { render, staticRenderFns } from "./AchievementsPanel.vue?vue&type=template&id=53d409ac&scoped=true"
import script from "./AchievementsPanel.vue?vue&type=script&lang=js"
export * from "./AchievementsPanel.vue?vue&type=script&lang=js"
import style0 from "./AchievementsPanel.vue?vue&type=style&index=0&id=53d409ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d409ac",
  null
  
)

export default component.exports